import * as React from 'react'

export enum FontAwesomeIconType {
	Bell = 'bell',
	BellOutline = 'bell-o',
	Cross = 'times',
	Diamond = 'diamond',
	InfoCircle = 'info-circle',
	Check = 'check',
	CheckCircle = 'check-circle',
	ExclamationCircle = 'exclamation-circle',
	ExclamationTriangle = 'exclamation-triangle',
	ChevronUp = 'chevron-up',
	ChevronDown = 'chevron-down',
	ChevronLeft = 'chevron-left',
	ChevronRight = 'chevron-right',
	LargeClock = 'lg fa-clock-o',
	Bullhorn = 'bullhorn',
	Clock = 'clock-o',
	CaretDown = 'caret-down',
	Repeat = 'repeat',
	LargeInfoCircle = 'lg fa-info-circle',
	Trophy = 'trophy',
	Search = 'search',
	Copy = 'copy',
	Download = 'download',
	Home = 'home',
	User = 'user',
	Flask = 'flask',
	Bullseye = 'bullseye',
	Signal = 'signal',
	Users = 'users',
	ListAlt = 'list-alt',
	ShoppingCart = 'shopping-cart',
	History = 'history',
	DollarSign = 'dollar-sign',
	Cog = 'cog',
	SignOut = 'sign-out',
	Lock = 'lock',
	AngleDoubleLeft = 'angle-double-left',
	AngleDoubleRight = 'angle-double-right',
	Email = 'envelope',
	Times = 'times',
}

interface FontAwesomeIconProps {
	fontAwesomeName: FontAwesomeIconType
	className?: string
	fontSize: string
	color?: string
}

export function FontAwesomeIcon({ fontAwesomeName, className, fontSize, color = 'white' }: FontAwesomeIconProps) {
	return <span className={`fa fa-${fontAwesomeName} ${className}`} style={{ fontSize, color }} />
}
